import { useEffect } from 'react';
import styled from '@emotion/styled';
import TourPicture from 'views/anyguide/bookings/tour_picture';
// @ts-ignore
import customTourDefaultImage from 'views/anyguide/bookings/tour_picture/custom_tour_default.jpg';

const TourCover = styled.div`
  display: block;
  @media (max-width: 767px) {
    display: none;
  }
`;

const RoundedImageContainer = styled.div`
  overflow: hidden;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const CoverImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center bottom;
`;

interface PictureProps {
  tourPicture?: string;
  rounded?: boolean;
}

export const Picture = ({ tourPicture, rounded = false }: PictureProps) => {
  const picUrl = tourPicture || customTourDefaultImage;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <TourCover className="TourCover">
      {rounded ? (
        <RoundedImageContainer className="CoverRounded">
          <img alt="Tour" src={tourPicture} className="loading" />
        </RoundedImageContainer>
      ) : (
        <>
          <TourPicture
            defaultFor="tour"
            pictureUrl={tourPicture}
            alt="Tour"
            className="loading"
          />
          <CoverImage
            src={picUrl}
            alt="Tour Cover"
            className="MobileCheckout-CoverPhoto loading"
          />
        </>
      )}
    </TourCover>
  );
};
